<web-mitek-capture
  (capture)="onCapture($event)"
  (error)="onError($event)"
></web-mitek-capture>
